/**
 * Motion preference, read once per call rather than cached.
 *
 * A person can change this setting while the page is open, and a cached answer
 * would keep animating at someone who just asked it to stop. `matchMedia` is
 * cheap; the correctness is not worth trading for it.
 *
 * The stylesheet already neutralises CSS transitions and animations under
 * `prefers-reduced-motion`. This exists for the few places that animate from
 * script, where CSS cannot reach.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
